var React = require("react");
var ApplicationContext = require("../../config/ApplicationContext.js");

var Feature = require("../empty/Feature.jsx");

class EmptyLibraryCard extends React.Component {
    componentWillMount(){
		this.linkPackage = ApplicationContext.getPackageEditor();
    }

    render() {
        return (
        	<div>
	           	<div className="empty">
	           	<p>Import a Fusion Electronics library above to begin managing your library content.</p>
	            </div>

                <Feature idHub={this.props.idHub}/>
            </div>
        );
    }
}


module.exports = EmptyLibraryCard;
